import { UnitSystem } from '@ravago/shared/page-data/models/config';

export class PhysicalPropertiesUtils {
   public static getNumberFromCondition = (unit: UnitSystem, condition?: string): number => {
      const measurement = unit.id === 'SI' ? 'mm' : 'in';
      return parseFloat(condition?.replace(` ${measurement}`, '') ?? '0') ?? 0;
   };
}
